import { render, staticRenderFns } from "./Profile_Form.vue?vue&type=template&id=23b09c3c&"
import script from "./Profile_Form.vue?vue&type=script&lang=js&"
export * from "./Profile_Form.vue?vue&type=script&lang=js&"
import style0 from "./Profile_Form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports